//
//import ProviderDebtToPayService from '@/services/api/purchase/PchProviderDebtToPay'
import ProviderDebtToPayPendingHeaders from '@/views/Purchase/PchProviderDebtToPayPending/PchProviderDebtToPayPendingHeaders'
import ProviderDebtToPayPendingFilters from '@/views/Purchase/PchProviderDebtToPayPending/PchProviderDebtToPayPendingFilters'
import ProviderDebtToPayPendingService from '@/services/api/purchase/PchProviderDebtToPayPending'
import ProviderModel from '@/models/Purchase/PchProvider'
import ProviderPaymentDebtToPayHeaders from '@/views/Purchase/PchProviderPayment/PchProviderPaymentDebtToPayHeaders'
import ProviderPaymentPaymentFields from '@/views/Purchase/PchProviderPayment/PchProviderPaymentPaymentFields'
import ProviderPaymentPaymentHeaders from '@/views/Purchase/PchProviderPayment/PchProviderPaymentPaymentHeaders'

//
export default (props) => [
	{
		name: 'pch_provider_id',
		type: 'autocomplete-model',
		flex: {
			sm6: true,
			xs12: true,
		},
		props: {
			itemText: 'rut',
			itemValue: 'id',
			label: 'Rut',
			model: ProviderModel,
			noObject: true,
		},
	},
	{
		name: 'pch_provider_id',
		type: 'autocomplete-model',
		flex: {
			sm6: true,
			xs12: true,
		},
		props: {
			itemText: 'business_name',
			itemValue: 'id',
			label: 'Proveedor',
			model: ProviderModel,
			noObject: true,
		},
	},
	{
		name: 'raw_debt_to_pays',
		type: 'table-field',
		flex: {
			xs12: true,
		},
		props: {
			color: 'error darken-1',
			headers: ProviderPaymentDebtToPayHeaders,
			pickerProps: {
				filters: ProviderDebtToPayPendingFilters,
				headers: ProviderDebtToPayPendingHeaders,
				paramFilter: {
					pch_provider_id: props.pch_provider_id,
				},
				// paramSearch: 'pch_purchase_invoice_id',
				mapper: providerDebtToPayPending => providerDebtToPayPending.reset(),
				noDataText: 'Sin deudas al proveedor',
				noSearch: false,
				service: new ProviderDebtToPayPendingService().toList(),
			},
			showPicker: props.pch_provider_id != '',
			toolbarColor: 'error darken-1',
			toolbarTitle: 'Listado de deudas incluidas en el pago',
		},
	},
	{
		name: 'raw_payments',
		type: 'table-field',
		flex: {
			xs12: true,
		},
		props: {
			adderProps: {
        formProps: {
          fields: ProviderPaymentPaymentFields,
          submitText: 'agregar',
        },
        //mapper: props.selected_mapper,
        method: props.raw_payments_method,
        //methodError: props.selected_error,
        //methodSuccess: props.selected_success,
        //model: ProductServiceModel,
        //modelKey: 'product_service_id',
        resetData: {
          is_cyclic: false,
        },
        title: 'Agregar medio de pago',
			},
			color: 'success darken-1',
			headers: ProviderPaymentPaymentHeaders,
			showAdder: true,
			showRemove: true,
			toolbarColor: 'success darken-1',
			toolbarTitle: 'Listado de medios de pago',
		},
	},
	{
		name: 'raw_resume',
		type: 'table-field',
		flex: {
			xs12: true,
		},
		props: {
			checkable: false,
			headers: [
				{
					text: '',
					value: '_',
				},
				{
					classes: 'primary--text font-weight-medium text-uppercase',
					text: 'Diferencia',
					value: 'diff',
					format: 'currency',
					align: 'right',
					width: '10%',
				},
				{
					classes: 'error--text font-weight-medium text-uppercase',
					text: 'Deuda a pagar',
					value: 'debt',
					align: 'right',
					format: 'currency',
					width: '10%',
				},
				{
					classes: 'success--text font-weight-medium text-uppercase',
					text: 'Total a Pagar',
					value: 'paid',
					format: 'currency',
					align: 'right',
					width: '10%',
				},
			],
			//noPagination: true,
			showNativePagination: false,
			//noTools: true,
			toolbarTitle: 'Resumen de pago',
		},
	},
]